import { accessRole } from "../../../../helpers/access_role";

import React, { Fragment, Component, useRef, useEffect, useState } from "react";
import apiResponse from "../../../../services/apiResponse";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Label,
} from "reactstrap";

import { Link } from "react-router-dom";

import TableComponent from "./Components/TableComponent";
import IndexBloc from "../Employee/Blocs/IndexBloc";

const reformatDate = (date) => {
  const months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];
  const d = new Date(date);
  let dt = d.getDate();
  if (dt < 10) dt = "0" + dt;

  return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
};

const PegawaiView = (props) => {
  const indexBloc = new IndexBloc();
  const queryParams = new URLSearchParams(window.location.search);

  const [activeTab, setactiveTab] = useState("1");
  const activeRef = useRef();
  const inactiveRef = useRef();
  const [period, setPeriod] = useState();

  const secondaryRef = useRef();
  const exportExcel = () => activeRef.current.exportExcel();

  function handleButtonExport() {
    // alert('aaaaaaaaa')
    exportExcel();
  }

  useEffect(() => {
    indexBloc.fetchDetailPeriode({ uuid: queryParams.get("period_uuid") });
    indexBloc.detailPeriodeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          setPeriod(result.data.response);
          break;
        default:
          break;
      }
    });
    return () => {
      indexBloc.detailPeriodeChannel?.unsubscribe();
    };
  }, []);

  const reloadSecondaryRef = () => secondaryRef.current.setTokenAPI();

  return (
    <Fragment>
      <Container fluid>
        <Card>
          <CardBody>
            <CardTitle>Daftar Pegawai Rapel</CardTitle>
            <CardSubtitle className="mb-3">
              {/* Daftar Urut Kepangkatan */}
            </CardSubtitle>
            <hr />
            <div className="float-end">
              {accessRole("create") ? (
                <Button
                  color="success"
                  type="button"
                  onClick={() => {
                    handleButtonExport();
                  }}
                >
                  Export Revisi
                </Button>
              ) : null}{" "}
              {period?.period_special_allowance_revision_status == 0 ? (
                <>
                  <Link
                    to={
                      `?addemployee&period_uuid=` +
                      queryParams.get("period_uuid")
                    }
                  >
                    <Button color="primary">Tambah Pegawai</Button>
                  </Link>
                </>
              ) : (
                ""
              )}
            </div>
            <Row className="mb-3">
              <Label className="col-md-2 col-form-label">Periode :</Label>
              <Label className="col-md-6 col-form-label">
                {period
                  ? period?.period_special_allowance_revision_periode
                  : "-"}
              </Label>
            </Row>
            <hr />
            <TableComponent
              ref={activeRef}
              handleProcessSuccess={reloadSecondaryRef}
              uuid={queryParams.get("period_uuid")}
              periode_name={
                period ? period?.period_special_allowance_revision_periode : "-"
              }
              periode_status={
                period ? period?.period_special_allowance_revision_status : "0"
              }
            />
            <div>
              <Link to="/kepegawaian/revisi_tunjangan_khusus.html">
                <Button color="danger">
                  <i className="uil-backspace"></i> Kembali
                </Button>
              </Link>
            </div>
          </CardBody>
        </Card>
      </Container>
    </Fragment>
  );
};

export default PegawaiView;
